import { snakeCase, camelCase } from 'change-case';
export const toKebabCase = (obj) => {
    return Object.entries(obj).reduce((acc, [key, item]) => ({ ...acc, [snakeCase(key)]: item }), {});
};
export const toCamelCase = (obj) => {
    return Object.entries(obj).reduce((acc, [key, item]) => ({ ...acc, [camelCase(key)]: item }), {});
};
